<dw-ui-dialog-box
  [title]="'Doc::CustomerSalesPurchase:Proforma' | abpLocalization"
  [saveLabel]="'Doc::Generate' | abpLocalization"
  (saveFn)="generateProforma()"
>
  <div class="row">
    <div class="col">
      <form [formGroup]="form">
        <div class="card-group header card-col mt-2 mb-3">
          <div class="card">
            <div class="row p-2">
              <div class="col col-md-6">
                <label for="reference" class="text-primary">
                  {{ 'Doc::CustomerReference' | abpLocalization }}
                </label>
                <input
                  type="text"
                  id="reference"
                  class="form-control"
                  formControlName="reference"
                />
              </div>
            </div>
            <div class="row p-2">
              <div class="col col-md-6">
                <label for="printTemplateId" class="form-label text-primary" dwInputRequired>
                  {{ 'Doc::DayBook:PrintTemplates' | abpLocalization }}
                </label>
                <ng-select
                  class="form-control"
                  id="printTemplateId"
                  formControlName="printTemplateId"
                  bindLabel="name"
                  bindValue="id"
                  [clearable]="false"
                  [items]="docPrintTemplatesEntities()"
                  [loading]="docPrintTemplatesTypeStore.loading()"
                >
                </ng-select>
              </div>
            </div>
            <div class="row p-2">
              <div class="col col-md-6 d-flex align-items-end">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="sendProforma"
                    formControlName="sendProforma"
                  />
                  <label for="sendProforma" class="form-check-label text-primary">
                    {{ 'Doc::CustomerSalesPurchase:SendProforma' | abpLocalization }}
                  </label>
                </div>
              </div>
            </div>
            @if (this.form.get('sendProforma').value) {
              <div class="row p-2">
                <div class="col col-md-6">
                  <label for="textTemplateId" class="form-label text-primary">
                    {{ 'Doc::CustomerSalesPurchase:TextTemplateId' | abpLocalization }}
                  </label>
                  <ng-select
                    class="form-control"
                    id="textTemplateId"
                    formControlName="textTemplateId"
                    bindLabel="name"
                    bindValue="id"
                    [items]="textTemplates()"
                  >
                  </ng-select>
                </div>
              </div>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
</dw-ui-dialog-box>
